// 图片动作
export const IMGS_ACCTION_TYPE = {
    STATIC: 1, // 静态图片
    JUMP: 2 // 点击跳转
}

// 官网地址
export const WEBSITE_URL = 'https://web.didiglobal.com/mx/tarjeta-de-credito/'
